"use client";

import { CmsSlotGridParameters, CmsSlotPageParameters, CmsSlotParameters, CmsSlotType } from "@/data/types";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from "@mui/material";

type Props = {
  type: CmsSlotType;
  parameters: CmsSlotParameters;
  setSlotParameters: (parameters: CmsSlotParameters) => void;
};

function isGrid(type: CmsSlotType, _parameters: CmsSlotParameters): _parameters is CmsSlotGridParameters {
  return type === CmsSlotType.Grid;
}
function isPage(type: CmsSlotType, _parameters: CmsSlotParameters): _parameters is CmsSlotPageParameters {
  return type === CmsSlotType.Page;
}

export default function CmsSlotParametersEditor({ type, parameters, setSlotParameters }: Props) {
  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={parameters.card ?? false}
              onChange={(e) => setSlotParameters({ ...parameters, card: e.target.checked })}
            />
          }
          label="Display in Card"
        />
      </Grid>
      {isPage(type, parameters) && (
        <Grid size={{ xs: 12, sm: 6 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={parameters.patreonOnly ?? false}
                onChange={(e) => setSlotParameters({ ...parameters, patreonOnly: e.target.checked })}
              />
            }
            label="Patreon only"
          />
        </Grid>
      )}
      {isGrid(type, parameters) && (
        <>
          <Grid size={{ xs: 12, sm: 6 }}>
            <FormControl size="small" fullWidth>
              <InputLabel>Justify Content</InputLabel>
              <Select
                label="Justify Content"
                title="Justify Content"
                size="small"
                value={parameters.justifyContent || ""}
                onChange={(e) => {
                  setSlotParameters({ ...parameters, justifyContent: e.target.value });
                }}
              >
                <MenuItem value={""}>None</MenuItem>
                <MenuItem value={"start"}>Start</MenuItem>
                <MenuItem value={"stretch"}>Stretch</MenuItem>
                <MenuItem value={"center"}>Center</MenuItem>
                <MenuItem value={"end"}>End</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              label="Columns (Mobile)"
              title="Columns (Mobile)"
              size="small"
              fullWidth
              value={parseInt(parameters.columns as any) || ""}
              type="number"
              onChange={(e) => {
                const intValue = parseInt(e.target.value);
                setSlotParameters({ ...parameters, columns: isNaN(intValue) ? undefined : intValue });
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              label="Columns (Desktop)"
              title="Columns (Desktop)"
              size="small"
              fullWidth
              value={parseInt(parameters.columnsDesktop as any) || ""}
              type="number"
              onChange={(e) => {
                const intValue = parseInt(e.target.value);
                setSlotParameters({ ...parameters, columnsDesktop: isNaN(intValue) ? undefined : intValue });
              }}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}
